const autoNgTemplateLoaderTemplate1 = require('./add-recipe.template.html');
const autoNgTemplateLoaderTemplate2 = require('./add-recipe.template.html');
const autoNgTemplateLoaderTemplate3 = require('./add-recipe.template.html');

'use strict';

import { NAVIGATION_ICON } from '../../modules/shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.addRecipe', [])
        .config(addRecipeConfig);

    addRecipeConfig.$inject = ['$routeProvider'];

    function addRecipeConfig($routeProvider) {
        $routeProvider
            .when('/angular/add-recipe', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'AddRecipeController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                    breadcrumbs: [
                        { label: 'Add Recipe', icon: NAVIGATION_ICON.MENU_BOOK }
                    ]
                }
            })
            .when('/angular/add-recipe/:id', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate2,
                controller: 'AddRecipeController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                    breadcrumbs: [
                        { label: 'Add Recipe', icon: NAVIGATION_ICON.MENU_BOOK }
                    ]
                }
            })
            .when('/angular/edit-recipe/:id', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate3,
                controller: 'AddRecipeController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                    breadcrumbs: [
                        { label: 'Edit Recipe', icon: NAVIGATION_ICON.MENU_BOOK }
                    ]
                }
            })
    }
})();
